import React from "react";

import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Dropzone from "./Dropzone";

import type { JSX } from "react";
import type { Accept } from "react-dropzone";

interface UploadZoneProps {
  name: string;
  isRequired?: boolean;
  isMultiple?: boolean;
  uploadProgress?: number;
  isUploadSuccess: boolean;
  isUploadError: boolean;
  accept?: Accept;
  acceptText?: string;
  withoutPreview?: boolean;
  isClearable?: boolean;
  onClear?: () => void;
  clearableText?: string;
  initialPreviewUrl?: string;
}

export default function UploadZone({
  name,
  isRequired,
  isMultiple,
  uploadProgress,
  isUploadSuccess,
  isUploadError,
  accept,
  acceptText,
  withoutPreview,
  isClearable,
  clearableText,
  initialPreviewUrl,
  onClear,
}: UploadZoneProps): JSX.Element {
  const { control, getFieldState } = useFormContext();
  const { t } = useTranslation("editor-errors");

  const isInvalid = getFieldState(name)?.invalid;

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange } }): JSX.Element => (
        <Dropzone
          accept={accept}
          acceptText={acceptText}
          clearableText={clearableText}
          initialPreviewUrl={initialPreviewUrl}
          isClearable={isClearable}
          isInvalid={isInvalid}
          isMultiple={isMultiple}
          isUploadError={isUploadError}
          isUploadSuccess={isUploadSuccess}
          onChange={onChange}
          onClear={onClear}
          uploadProgress={uploadProgress}
          withoutPreview={withoutPreview}
        />
      )}
      rules={{
        required: isRequired && t("requiredField"),
      }}
    />
  );
}
